"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToLanguageCodeCase = void 0;
/**
 * Convert a string to the character case that LanguageCode uses
 */
function stringToLanguageCodeCase(value) {
    return value.toLowerCase();
}
exports.stringToLanguageCodeCase = stringToLanguageCodeCase;
//# sourceMappingURL=stringToLanguageCodeCase.js.map